<mat-card appearance="outlined">
  <form>
    <mat-card-content>
      <quill-editor style="width: 100%;" [(ngModel)]="content"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="getClass()"
                    [required]="true"
                    [placeholder]="'Ecrire ici votre message ou commentaire...'"
                    [modules]="modules"
                    [formats]="formats">
      </quill-editor>

      <div *ngIf="hasPrivate">
        <mat-tab-group  mat-stretch-tabs="false" mat-align-tabs="start"
                        [selectedIndex] = "selectedTab" #matTabGroup
                       (focusChange)="onChangedType($event)">
          <mat-tab label="{{labelPublic}}"></mat-tab>
          <mat-tab *ngIf="hasPrivate"
                   label="{{labelPrivate}}"></mat-tab>
        </mat-tab-group>
      </div>
      <ng-container *ngIf="hasFilesToUpload">
        <mat-card appearance="outlined">
          <mat-card-subtitle [fxLayoutAlign]="'end center'" *ngIf="labelJoinFiles">{{labelJoinFiles}} {{labelFileMaxsize}}</mat-card-subtitle>
          <mat-card-actions align="{{alignFilesUpload}}">
            <p8-attachments [application]="application"
                            [accept]="acceptFiles"
                            [maxFiles]="maxFiles"
                            [maxFileSize]="maxFileSize"
                            [connector]="uploaderConnector"
                            [colorButton]="colorButton"
                            [typeButton]="typeFileButton"
                            [uploading$]="uploading$"
                            (onFinished)="handleFilesUploaded($event)"
                            (onUpdatedFiles)="hasAttachmentsToUpload($event)"
                            [disabled]="!content || sendingComment">
            </p8-attachments>
          </mat-card-actions>
        </mat-card>
      </ng-container>
    </mat-card-content>

    <mat-card-actions [align]="alignButtonsSendCancel">
      <div>
        <mat-progress-bar [mode]="'indeterminate'" *ngIf="sendingComment"></mat-progress-bar>
        <button mat-raised-button color="primary"
                [disabled]="! content || sendingComment"
                (click)="sendComment()">{{labelButtonSend}}</button>
      </div>
    </mat-card-actions>
  </form>
</mat-card>

